import { render, staticRenderFns } from "./PelunasanBL.vue?vue&type=template&id=c927baf8&scoped=true&"
import script from "./PelunasanBL.vue?vue&type=script&lang=js&"
export * from "./PelunasanBL.vue?vue&type=script&lang=js&"
import style0 from "./PelunasanBL.vue?vue&type=style&index=0&id=c927baf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927baf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VIcon,VRow,VTextField})
